import {httpUtil} from './httpUtil'
import {ErrorCodes, createResult, createCommonResult} from './resultUtil'

export const communications={
  //getAccounts,
  getCommunications,
  getUnreadCommunications,
  deleteCommunication,
  setRead,
}



async function getCommunications({
  page=1,
  size=20,
  sort,//='UPDATED_DATE',
  order, //='DESC',
  channel,
  viewed,
  archived,
}={})
{
  return listCommunications({
    page,
    size,
    sort,//='UPDATED_DATE',
    order, //='DESC',
    channel : 'INAPP', //set to inapp when ready
    archived : false,
  })
}
async function listCommunications(
{
  page=1,
  size=10,
  sort,//='UPDATED_DATE',
  order, //='DESC',
  channel,
  viewed,
  archived
}={}, ){
  try {
    let id = httpUtil.getSession().sub;
    //console.log('API: ', contact)
    let response = await httpUtil.get({
      resourcePath: '/v1/contacts/' + id + '/communications',
      queryParams: {
        page,
        size,
        sort,
        order,
        channel,
        viewed,
        archived,
      },
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception getCommunications: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}



async function getUnreadCommunications({
  page=1,
  size=10,
  sort,//='UPDATED_DATE',
  order, //='DESC',
  viewed,
  archived,
}={})
{
  return listCommunications({
    page,
    size,
    sort,//='UPDATED_DATE',
    order, //='DESC',
    channel : 'INAPP', //set to inapp when ready
    archived : false,
    viewed: false
  })
}

async function deleteCommunication(commId){
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.put({
      resourcePath: '/v1/communications/' + commId + '/actions',
      body: {
        archived:true,
      },
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception deleteCommunication: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}

async function setRead(commId){
  try {
    //console.log('API: ', contact)
    let response = await httpUtil.put({
      resourcePath: '/v1/communications/' + commId + '/actions',
      body: {
        viewed:true,
      },
      withAccessToken: true
    });
    //check return code here instead of put as there would be different intepretation for different API
    return createCommonResult(response);
  } catch (e) {
    console.log('Exception setRead: ', e);
    return createResult(ErrorCodes.UNKNOWN, e);
  }
}
